(function () {
  var ui = document.querySelector('[data-music-player]');
  if (!ui) return;

  var src = ui.getAttribute('data-src');
  var toggle = ui.querySelector('[data-music-toggle]');
  var icon = ui.querySelector('[data-music-icon]');

  if (!src || !toggle || !icon) return;

  var timeKey = 'site_music_time';
  var playingKey = 'site_music_playing';

  var audio = document.createElement('audio');
  audio.src = src;
  audio.loop = true;
  audio.preload = 'auto';
  audio.style.display = 'none';
  document.body.appendChild(audio);

  function updateUI() {
    var playing = !audio.paused;
    ui.classList.toggle('is-playing', playing);
    icon.textContent = playing ? '❚❚' : '▶';
    toggle.setAttribute('aria-pressed', playing ? 'true' : 'false');
  }

  function saveState() {
    localStorage.setItem(timeKey, String(audio.currentTime || 0));
    localStorage.setItem(playingKey, audio.paused ? 'false' : 'true');
  }

  audio.addEventListener('loadedmetadata', function () {
    var savedTime = parseFloat(localStorage.getItem(timeKey));
    var shouldPlay = localStorage.getItem(playingKey) === 'true';

    if (!isNaN(savedTime) && savedTime > 0 && savedTime < audio.duration) {
      audio.currentTime = savedTime;
    }

    if (shouldPlay) {
      audio.play().then(updateUI).catch(updateUI);
    } else {
      updateUI();
    }
  });

  toggle.addEventListener('click', function (event) {
    event.preventDefault();
    event.stopPropagation();

    if (audio.paused) {
      localStorage.setItem(playingKey, 'true');
      audio.play().then(updateUI).catch(updateUI);
    } else {
      localStorage.setItem(playingKey, 'false');
      audio.pause();
      updateUI();
    }
  });

  audio.addEventListener('timeupdate', saveState);
  audio.addEventListener('play', saveState);
  audio.addEventListener('pause', saveState);
  window.addEventListener('pagehide', saveState);
  window.addEventListener('beforeunload', saveState);

  updateUI();
})();